// extracted by mini-css-extract-plugin
export default {"config-wrapper":"service_config-wrapper__zg6ik","config-row":"service_config-row__J2nD0","config-col":"service_config-col__OR1Bn"};